import React, { useEffect } from "react";
import {
  FiAlertCircle,
  FiCheckCircle,
  FiInfo,
  FiXCircle,
} from "react-icons/fi";

import { tokens } from "../../../../design/tokens";

import { useToast, ToastMessage } from "../../../../hooks/toast";

import { Container } from "./sytles";

interface ToastProps {
  message: ToastMessage;
  style: object;
}

const icons = {
  /* Era #545454, um cinza medio fora da paleta. Sobre o ouro o icone usa o
     mesmo Carvao de Tinta do texto, entao os dois falam a mesma cor. */
  info: <FiInfo size={24} color={tokens.color.inkCharcoal} />,
  success: <FiCheckCircle size={24} />,
  error: <FiAlertCircle size={24} />,
};

const Toast: React.FC<ToastProps> = ({ message, style }) => {
  const { removeToast } = useToast();

  useEffect(() => {
    const timer = setTimeout(() => {
      removeToast(message.id);
    }, 3000);

    return () => {
      clearTimeout(timer);
    };
  }, [message.id, removeToast]);

  return (
    <Container
      type={message.type}
      description={Number(!!message.description)}
      style={style}
    >
      {icons[message.type || "info"]}

      <div>
        <strong>{message.title}</strong>
        {message.description && <p>{message.description}</p>}
      </div>

      <button type="button" onClick={() => removeToast(message.id)}>
        <FiXCircle size={18} />
      </button>
    </Container>
  );
};

export default Toast;
